/* ============================================================
   Líder — PDP: galeria, variantes (chips), quantidade e compra AJAX
   ============================================================ */
(function () {
  'use strict';

  var money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  function fmt(cents) { return money.format(cents / 100); }

  function refreshBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-lider-cart-count]').forEach(function (b) {
          b.textContent = c.item_count < 100 ? c.item_count : '99';
          b.hidden = c.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function openDrawer() {
    if (window.LiderCart && typeof window.LiderCart.openRefreshed === 'function') {
      window.LiderCart.openRefreshed();
    }
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-lider-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionCount = parseInt(root.dataset.options, 10) || 1;
    var priceEl = root.querySelector('[data-lider-price]');
    var compareEl = root.querySelector('[data-lider-compare]');
    var offEl = root.querySelector('[data-lider-off]');
    var pixEl = root.querySelector('[data-lider-pix]');
    var instEl = root.querySelector('[data-lider-installment]');
    var idInput = root.querySelector('[data-lider-variant-id]');
    var addBtn = root.querySelector('[data-lider-atc]');
    var buyBtn = root.querySelector('[data-lider-buynow]');
    var qtyInput = root.querySelector('[data-lider-qty]');

    function selectedOptions() {
      var opts = [];
      for (var i = 1; i <= optionCount; i++) {
        var chip = root.querySelector('[data-lider-chip][data-option-index="' + i + '"].is-selected');
        opts.push(chip ? chip.dataset.value : null);
      }
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        for (var i = 0; i < opts.length; i++) {
          if (opts[i] !== null && v.options[i] !== opts[i]) return false;
        }
        return true;
      });
    }
    function currentVariant() { return findVariant(selectedOptions()); }

    function sync() {
      var v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponível'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmt(v.price);
      if (instEl) instEl.textContent = fmt(Math.round(v.price / 4));
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = fmt(v.compare_at_price);
          compareEl.hidden = false;
          if (offEl) {
            var off = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
            offEl.textContent = '-' + off + '%';
            offEl.hidden = false;
          }
        } else {
          compareEl.hidden = true;
          if (offEl) offEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? (addBtn.dataset.label || 'Adicionar ao carrinho') : 'Esgotado';
      }
      if (buyBtn) buyBtn.disabled = !v.available;

      root.querySelectorAll('[data-lider-chip][data-option-index="' + optionCount + '"]').forEach(function (chip) {
        var opts = selectedOptions();
        opts[optionCount - 1] = chip.dataset.value;
        var vv = findVariant(opts);
        chip.classList.toggle('is-unavailable', !vv || !vv.available);
      });
    }

    root.querySelectorAll('[data-lider-chip]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var idx = chip.dataset.optionIndex;
        root.querySelectorAll('[data-lider-chip][data-option-index="' + idx + '"]').forEach(function (c) {
          c.classList.toggle('is-selected', c === chip);
        });
        sync();
      });
    });

    root.querySelectorAll('[data-lider-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = parseInt(btn.dataset.liderQtyBtn, 10);
        var val = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
        qtyInput.value = val;
      });
    });

    function currentItems() {
      var v = currentVariant();
      if (!v || !v.available) return null;
      return [{ id: v.id, quantity: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1) }];
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var items = currentItems();
        if (!items) return;
        var original = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = 'Adicionando…';
        addToCart(items)
          .then(function () {
            addBtn.textContent = 'Adicionado ✓';
            refreshBubble();
            openDrawer();
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2200);
          })
          .catch(function (err) {
            addBtn.textContent = (err && err.description) ? err.description : 'Erro — tente de novo';
            setTimeout(function () { addBtn.textContent = original; addBtn.disabled = false; }, 2600);
          });
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var items = currentItems();
        if (!items) return;
        buyBtn.disabled = true;
        addToCart(items)
          .then(function () { window.location.href = '/checkout'; })
          .catch(function () { buyBtn.disabled = false; });
      });
    }

    /* galeria */
    var slides = root.querySelectorAll('[data-lider-slide]');
    root.querySelectorAll('[data-lider-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var idx = thumb.dataset.liderThumb;
        root.querySelectorAll('[data-lider-thumb]').forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
        slides.forEach(function (s) {
          s.hidden = s.dataset.liderSlide !== idx;
        });
      });
    });

    sync();
  }

  function init() {
    document.querySelectorAll('[data-lider-pp]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
